<div class="module module-attendace">
      <div class="module-title">
          <h3>Links Úteis</h3> 
      </div>
      <div class="module-content">
          <div class="nav-menu">
              <ul>
                  <li>
                      <a routerLink="/contato" title="Fale Conosco" (click)="toRoute('/contato')">
                          <span>Fale Conosco</span>
                      </a>
                  </li> 
                  <li>
                    <a routerLink="/cuidado-com-suas-joias" title="Cuidados com suas joias" (click)="toRoute('/servicos/cuidados-com-suas-joias')">
                        <span>Cuidados com suas joias</span>
                    </a> 
                  </li> 
                  <li>
                      <a routerLink="perguntas-frequentes" title="Perguntas Frequentes" (click)="toRoute('/perguntas-frequentes')">
                          <span>Perguntas Frequentes</span>
                      </a>
                  </li>  
                  <li> 
                      <a routerLink="formas-de-pagamento" title="Formas de Pagamento" (click)="toRoute('/formas-de-pagamento')">
                          <span>Formas de Pagamento</span>
                      </a>
                  </li>  
                  <li>
                      <a routerLink="politica-de-garantia" title="Política de Garantia" (click)="toRoute('/politicas-de-garantia')">
                          <span>Política de Garantia</span>
                      </a>
                  </li>
                  <li>
                      <a routerLink="politica-de-conserto" title="Política de Conserto" (click)="toRoute('/politicas-de-conserto')">
                          <span>Política de Conserto</span>
                      </a>
                  </li> 
                  <li>
                      <a routerLink="politica-de-troca" title="Política de Troca e Devolução" (click)="toRoute('/politicas-de-troca')">
                          <span>Política de Troca e Devolução</span>
                      </a>
                  </li> 
                  <li>  
                    <a routerLink="politica-de-troca" title="Política de Privacidade" (click)="toRoute('/politicas-de-privacidade')">
                        <span>Políticas de Privacidade</span>
                    </a>
                </li>     
              </ul>   
          </div>    
      </div>
</div>